// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-call-card {
  height: 74px;
  width: 100%;
  opacity: 1;
  padding: 18px 20px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 12px #0000000A;
  border-radius: 8px;
}

.welcome-call-card .ant-typography {
  font-size: 20px;
  line-height: 26px;
}

.welcome-call-card .ant-btn {
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  padding: 9px 16px 8px 16px;
  border-radius: 4px;
  opacity: 1;
  letter-spacing: 0.64px;
  background: #2E6EDF 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #00000014;
  border-radius: 4px;
  opacity: 1;
  color: #FFFFFF;
}

.welcome-call-card .ant-btn:hover {
  background: #2E6EDF 0% 0% no-repeat padding-box;
  color: #FFFFFF;
}

.home {
  border-radius: 0px 0px 8px 8px !important;
  background: transparent linear-gradient(270deg, #56A8F7 0%, #6C7BD4 100%) 0% 0% no-repeat padding-box !important;
}

.home .ant-typography {
  color: #FFFFFF !important;
}

.welcome-call-card .ant-typography {
  color: #2E6EDF;
  opacity: 1;
}

.home .ant-btn, .home .ant-btn:hover {
  color: #56A8F7 !important;
  background: #FFFFFF 0% 0% no-repeat padding-box !important;
}

.welcome-call-question {
  margin-right: 24px;
}`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/shared/WelcomeCall/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,+CAA+C;EAC/C,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,+CAA+C;EAC/C,iCAAiC;EACjC,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,gHAAgH;AAClH;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".welcome-call-card {\n  height: 74px;\n  width: 100%;\n  opacity: 1;\n  padding: 18px 20px;\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  box-shadow: 0px 0px 12px #0000000A;\n  border-radius: 8px;\n}\n\n.welcome-call-card .ant-typography {\n  font-size: 20px;\n  line-height: 26px;\n}\n\n.welcome-call-card .ant-btn {\n  font-weight: 500;\n  font-size: 16px;\n  text-align: center;\n  padding: 9px 16px 8px 16px;\n  border-radius: 4px;\n  opacity: 1;\n  letter-spacing: 0.64px;\n  background: #2E6EDF 0% 0% no-repeat padding-box;\n  box-shadow: 0px 2px 4px #00000014;\n  border-radius: 4px;\n  opacity: 1;\n  color: #FFFFFF;\n}\n\n.welcome-call-card .ant-btn:hover {\n  background: #2E6EDF 0% 0% no-repeat padding-box;\n  color: #FFFFFF;\n}\n\n.home {\n  border-radius: 0px 0px 8px 8px !important;\n  background: transparent linear-gradient(270deg, #56A8F7 0%, #6C7BD4 100%) 0% 0% no-repeat padding-box !important;\n}\n\n.home .ant-typography {\n  color: #FFFFFF !important;\n}\n\n.welcome-call-card .ant-typography {\n  color: #2E6EDF;\n  opacity: 1;\n}\n\n.home .ant-btn, .home .ant-btn:hover {\n  color: #56A8F7 !important;\n  background: #FFFFFF 0% 0% no-repeat padding-box !important;\n}\n\n.welcome-call-question {\n  margin-right: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
